import { casPrimitives, casThemeVariables } from './cas-tokens.generated';

export const cssColour = (hex: string, alpha = 1): string =>
  alpha === 1
    ? hex
    : `rgba(${[1, 3, 5]
        .map((start) => parseInt(hex.slice(start, start + 2), 16))
        .join(', ')}, ${alpha})`;

// plain rgba for hex values, since older Safari versions we support lack color-mix
export const colourWithAlpha = (value: string, alpha: number): string =>
  value.startsWith('#')
    ? cssColour(value, alpha)
    : `color-mix(in srgb, ${value} ${
        Math.round(alpha * 1000) / 10
      }%, transparent)`;

type PrimitiveValues<T> = T extends readonly number[]
  ? string
  : { readonly [K in keyof T]: PrimitiveValues<T[K]> };

const toCss = (channels: readonly number[]): string =>
  channels.length === 4
    ? `rgba(${channels.join(', ')})`
    : `#${channels
        .map((channel) => channel.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase()}`;

const toValues = <T>(node: T): PrimitiveValues<T> =>
  (Array.isArray(node)
    ? toCss(node)
    : Object.fromEntries(
        Object.entries(node as Record<string, unknown>).map(([key, child]) => [
          key,
          toValues(child),
        ]),
      )) as PrimitiveValues<T>;

export const colour = {
  ...toValues(casPrimitives),
  ...casThemeVariables,
};

// Accent colours with no CAS equivalent yet; design question 3 decides their future.
/** @deprecated not in CAS; waiting on a design decision (see the CAS colours Notion doc). */
export const magenta = '#CF2FB3';
/** @deprecated not in CAS; waiting on a design decision (see the CAS colours Notion doc). */
export const iris = '#8C4E9F';
/** @deprecated not in CAS; a stop of the preliminary findings gradient, waiting on the gradient design question. */
export const findingsTeal = '#1491B2';
/** @deprecated not in CAS; a stop of the preliminary findings gradient, waiting on the gradient design question. */
export const findingsGreen = '#299C86';
